import React from "react";
import { Box, LinearProgress, Typography } from "@mui/material";

interface ICodingProgressIndicatorProps {
    roundNumber: number;
    currentItemsCoded: number;
    totalItems: number;
}

const CodingProgressIndicator: React.FC<ICodingProgressIndicatorProps> = (props: ICodingProgressIndicatorProps) => {
    const { roundNumber, currentItemsCoded, totalItems } = props;
    const percentComplete = totalItems > 0 ? (currentItemsCoded / totalItems) * 100.0 : 0;

    return (
        <Box sx={{ width: "100%", marginBottom: "16px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    Round {roundNumber}:
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {currentItemsCoded} / {totalItems} labeled
                </Typography>
            </Box>
            <LinearProgress
                variant="determinate"
                value={percentComplete}
                sx={{ height: 4, borderRadius: 2 }}
            />
        </Box>
    )
}

export default CodingProgressIndicator;
